import React from 'react';

interface StowagePlanNotFoundMessageProps {
    vesselName: string;
}

const StowagePlanNotFoundMessage: React.FC<StowagePlanNotFoundMessageProps> = ({ vesselName }) => {
    return (
        <div>
            The stowage plan for <b>{vesselName}</b> could not be found. This may happen for several reasons:
            <br />
            <br />
            • The plan may not exist or has been removed.
            <br />
            • You may not have permission to access this plan.
            <br />
            • If this is a draft plan, it is only visible to its creator.
            <br />
            <br />
            You will be redirected to the master plan for this vessel.
        </div>
    );
};

export default StowagePlanNotFoundMessage;
